export const WorkoutPlayerFinishModal = {
  bindings: {
    isFinished: '<',
    onFinish: '&',
  },

  template: `
    <a
      href="#"
      ng-click="$ctrl.show()"
      ng-if="!$ctrl.isFinished">
      Finish
    </a>
    <div class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-center">
            <h5 class="modal-title m-auto">
              Are you sure you are done?
            </h5>
          </div>
          <div class="modal-footer justify-content-center">
            <button-primary ng-click="$ctrl.onFinish(); $ctrl.hide()">
              Yes
            </button-primary>
            <button-primary
              is-inverse="'true'"
              data-dismiss="modal">
              No
            </button-primary>
          </div>
        </div>
      </div>
    </div>`,

  controller($element) {
    'ngInject';

    return {
      $onInit() {
        this.modal = $element.find('.modal');
      },

      show() {
        this.modal.modal();
      },

      hide() {
        this.modal.modal('hide');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/WorkoutPlayer/WorkoutPlayerFinishModal.js